module.exports = __webpack_public_path__ + "img/Rivian_stacked_white_062424.a810e306.png";